import { Download } from 'lucide-react';

import { Button, type ButtonProps } from '@design-system';
import { useCarePacketDownload } from '@/hooks/useCarePacketDownload';
import { cn } from '@/lib/utils';

interface DownloadCarePacketButtonProps {
  applicationId: string;
  clientId: string;
  filesToDownload: string[];
  text?: string;
  onDownloadComplete: () => void;
  buttonProps?: Omit<ButtonProps, 'disabled' | 'onClick'>;
}

export function DownloadCarePacketButton({
  filesToDownload,
  onDownloadComplete,
  applicationId,
  clientId,
  text = 'Download Take Home Packet to Continue',
  buttonProps,
}: DownloadCarePacketButtonProps) {
  const { downloadCarePacket, isDownloading } = useCarePacketDownload({
    applicationId,
    clientId,
    filesToDownload,
    onDownloadComplete,
  });

  const { className, variant = 'outline', size = 'sm', ...restButtonProps } = buttonProps ?? {};
  return (
    <Button
      variant={variant}
      size={size}
      className={cn('cursor-pointer gap-2', className)}
      {...restButtonProps}
      onClick={downloadCarePacket}
      disabled={isDownloading}
    >
      <Download className="h-4 w-4 cursor-pointer" />
      {isDownloading ? 'Downloading...' : text}
    </Button>
  );
}
